import React, { useMemo } from 'react';
import { Table } from '@raptormaps/table';
import { Text } from '@raptormaps/text';
import { SolarInspection } from '../../api/schemas/SolarFarmSchema';
import { formatTimestamp } from '../../utils/general_utils';

const COLS = [
  { name: 'ID', key: 'id' },
  { name: 'Name', key: 'name' },
  { name: 'Status', key: 'status' },
  { name: 'Power Inspected', key: 'powerInspected' },
  { name: 'Verified', key: 'verified' },
  { name: 'Date', key: 'date' },
] as const;

export function InspectionsTable({
  inspections,
}: {
  inspections: SolarInspection[];
}) {
  const tableData = useMemo(
    () =>
      inspections.map(insp => ({
        rowId: String(insp.id ?? insp.uuid ?? ''),
        id: insp.id ?? '—',
        name: insp.name ?? '—',
        status: insp.status !== null ? String(insp.status) : '—',
        powerInspected:
          insp.power_inspected !== null ? `${insp.power_inspected} MW` : '—',
        verified:
          insp.verified == null ? (
            '—'
          ) : (
            <Text
              as="span"
              className={
                insp.verified
                  ? 'fd-badge fd-badge--green'
                  : 'fd-badge fd-badge--gray'
              }
            >
              {insp.verified ? 'Yes' : 'No'}
            </Text>
          ),
        date: formatTimestamp(insp.inspection_tsecs),
      })),
    [inspections],
  );

  if (inspections.length === 0) return null;

  return (
    <div className="fd-inspections-section">
      <div className="fd-inspections-header">
        <Text variant="paragraph_medium_bold">
          Inspections{' '}
          <Text variant="paragraph_medium" color="neutral_600" as="span">
            ({inspections.length})
          </Text>
        </Text>
      </div>
      <Table
        cols={COLS as unknown as Array<{ name: string; key: string }>}
        data={tableData}
        totalRowCount={inspections.length}
        paginationPageSize={Math.max(inspections.length, 10)}
        hideControls
        fetchData={async () => {}}
      />
    </div>
  );
}
